import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import Loading from 'components/global/Loading';

import Layout from 'pages/Login/Layout';

import PATHS from 'utils/paths';

const PublicRoutes = () => {
	const navigate = useNavigate();
	const isUserAuthenticated = !!localStorage.getItem('ACCESS_TOKEN');

	useEffect(() => {
		if (isUserAuthenticated) {
			navigate(PATHS.BASE, {
				replace: true
			});
		}
	}, []);

	return (
		!isUserAuthenticated && (
			<Layout>
				<Suspense fallback={<Loading />}>
					<Outlet />
				</Suspense>
			</Layout>
		)
	);
};

export default PublicRoutes;
